// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dOOX0exkSf8cn_0ygO6L{flex-direction:column;gap:20px;display:flex}.Jh9qwdIcLCgAGCxSx9P3{justify-content:flex-end;gap:8px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `dOOX0exkSf8cn_0ygO6L`,
	"actionsContainer": `Jh9qwdIcLCgAGCxSx9P3`
};
export default ___CSS_LOADER_EXPORT___;
